import UKFlagIcon from "./UKFlagIcon";
export default UKFlagIcon;
